import { useRef, useEffect } from 'react';
export const useInterval = (callback, delay) => {
    const savedCallback = useRef(callback);
    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    // Set up the interval.
    useEffect(() => {
        function tick() {
            savedCallback.current();
        }
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
};
//# sourceMappingURL=index.js.map